import React from 'react';
export function Footer() {
  return <footer className="w-full bg-navy px-4 py-12 text-center text-white/65" data-id="element-92" data-mp="32wd2qgad7ltj">
      <div className="mx-auto max-w-3xl" data-id="element-93" data-mp="3ggaovpzpm32t">
        <p className="font-serif text-2xl text-white" data-id="element-94" data-mp="3gh3qydnq44em">Therapeutic Reiki Guide</p>
        <p className="mt-3 text-sm font-semibold text-white/80" data-id="element-95" data-mp="32pp57z2flp3v">
          A complete self-guided professional Reiki resource system.
        </p>
        <p className="mt-3 text-sm leading-relaxed" data-id="element-96" data-mp="3ueik9th3kwbv">
          Because building a thriving energy healing practice is easier with a clear, structured
          system.
        </p>
        <p className="mt-6 text-sm" data-id="element-97" data-mp="3lecb2jsfmiii">
          📧{' '}
          <a className="transition-colors duration-200 hover:text-amber" href="mailto:support@eurekalabs.com" data-id="element-98" data-mp="3ldkg9b6nsota">
            support@eurekalabs.com
          </a>{' '}
          <span className="mx-2 text-white/30" data-id="element-99" data-mp="29xlymixf0ugg">·</span> 🌐 www.eurekalabs.store
        </p>
        <p className="mt-6 text-xs" data-id="element-100" data-mp="2ez1kuebbx70f">© Therapeutic Reiki Guide 2026 — All rights reserved.</p>
        <p className="mt-2 text-xs leading-relaxed text-white/55" data-id="element-101" data-mp="3lalf9cv8a1sw">
          EurekaLabs is operated by DEFGROUP LLC, a limited liability company registered in
          Wyoming, United States.
        </p>
        <p className="mt-4 text-xs leading-relaxed text-white/45" data-id="element-102" data-mp="3v8hqs5s2uyrj">
          This product is a digital download. Results may vary. This system does not replace
          professional medical advice. Always refer clients to appropriate medical professionals
          when needed.
        </p>
      </div>
    </footer>;
}